import React, { useState } from "react";

export default function TextareaField({label, name, value, onChange, onBlur, onFocus, required = false, placeholder = "", rows = 4, maxLength, minLength, error,}) {
  const [isFocused, setIsFocused] = useState(false);
  const [charCount, setCharCount] = useState(value?.length || 0);

  const handleFocus = (e) => {
    setIsFocused(true);
    onFocus?.(e);
  };

  const handleBlur = (e) => {
    setIsFocused(false);
    onBlur?.(e);
  };

  const handleChange = (e) => {
    const newValue = e.target.value;
    setCharCount(newValue.length);

    if (onChange) {
      onChange({
        ...e,
        target: { ...e.target, name, value: newValue },
      });
    }
  };

  return (
    <div className="relative w-full sm:col-span-1 lg:col-span-4">
      <label
        htmlFor={name}
        className={`absolute left-3 px-1 bg-white transition-all duration-200 ${error ? "text-red-600" : "text-grey-500" } pointer-events-none ${ isFocused || value ? "text-xs -top-2.5 text-grey-800" : "text-sm top-3 pr-20" } `}>
        {label}
        {required ? "*" : ""}
      </label>
      <textarea
        id={name}
        name={name}
        value={value || ""}
        required={required}
        placeholder={placeholder}
        rows={rows}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        maxLength={maxLength}
        className={`
          w-full border rounded-md pr-3 pl-3 py-3 text-sm text-gray-800
          appearance-none bg-white transition-colors duration-200 focus:outline-none hover:border-grey-800 hover:border-1 resize-none
          ${
            error
              ? "border-red-500"
              : isFocused
              ? "border-grey-800 border-1"
              : "border-border"
          }
        `}      />
      <div className="flex justify-between items-center mt-1">
        {minLength && (
          <div className="text-xs text-gray-500">
            Minimum {minLength} characters required
          </div>
        )}
        {maxLength && (
          <div className={`text-xs ${minLength && charCount < minLength ? "text-red-500" : "text-gray-500"} ${!maxLength ? "w-full" : ""} text-right`}>
            {charCount}/{maxLength}
          </div>
        )}
      </div>
      {error && typeof error === 'string' && error.trim() !== '' && (
        <p className="mt-1 text-xs text-red-600">{error}</p>
      )}
    </div>
  );
}
